import axios from 'axios';
import * as types from '../types';
import * as popupWindow from '../utils/popupWindow';
import {API_URL, isProduction} from '../../common/configs/index';

const BACKEND_URL = API_URL;
export const OKNAME_URL = isProduction
  ? 'https://okname.xsolla.com'
  : 'http://test-okname.xsolla.com';

/**
 * I-Pin async request
 * @param dispatch
 */
export function ipinAsync(dispatch) {
  dispatch({type: types.IPIN_ATTEMPT});

  return popupWindow.open(`${OKNAME_URL}/ipin`, 'I-Pin', 450, 550);
}

/**
 * I-Pin callback verification async request
 * @param dispatch
 * @param data
 * @param locationQuery
 */
export function ipinCallbackAsync(dispatch, data, locationQuery) {
  dispatch({type: types.IPIN_VERIFICATION});

  return axios({
    method: 'GET',
    url: `${BACKEND_URL}okname/callback`,
    withCredentials: true,
    params: {
      projectId: locationQuery.projectId,
      token: locationQuery.token,
      login_url: locationQuery.login_url,
      data
    }
  })
    .then(response => {
      dispatch({type: types.IPIN_SUCCESSFULLY});

      if (typeof window !== 'undefined' && response.data.redirect_url) {
        window.top.location.href = response.data.redirect_url;
      }
    })
    .catch(() => {
      dispatch({type: types.IPIN_FAILED});
    });
}

/**
 * Sms async request
 * @param dispatch
 */
export function smsAsync(dispatch) {
  dispatch({type: types.SMS_ATTEMPT});

  return popupWindow.open(`${OKNAME_URL}/sms/auth`, 'Sms-auth', 450, 550);
}

/**
 * Sms callback verification async request
 * @param dispatch
 * @param data
 * @param locationQuery
 */
export function smsCallbackAsync(dispatch, data, locationQuery) {
  dispatch({type: types.SMS_VERIFICATION});

  return axios({
    method: 'GET',
    url: `${BACKEND_URL}okname/callback`,
    withCredentials: true,
    params: {
      projectId: locationQuery.projectId,
      token: locationQuery.token,
      login_url: locationQuery.login_url,
      data
    }
  })
    .then(response => {
      dispatch({type: types.SMS_SUCCESSFULLY});

      if (typeof window !== 'undefined' && response.data.redirect_url) {
        window.top.location.href = response.data.redirect_url;
      }
    })
    .catch(() => {
      dispatch({type: types.SMS_FAILED});
    });
}



// WEBPACK FOOTER //
// ./actions/verification.js